/** Shared schema helpers for Product/Service detail page sections. */

export const SECTION_TYPES = [
  { type: "hero", label: "Hero (image + features + CTAs)" },
  { type: "useCases", label: "Use cases (image + pill list)" },
  { type: "featureSplit", label: "Feature split (badge + image + card)" },
  { type: "featureList", label: "Feature list (title + points + image)" },
  { type: "infographics", label: "Infographics (image cards)" },
  { type: "table", label: "Table (specifications / grades)" }
];

function uid() {
  return `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
}

export function createEmptyPoint() {
  return { title: "", text: "" };
}

export function createEmptySection(type) {
  const base = { id: uid(), type, enabled: true };

  switch (type) {
    case "hero":
      return {
        ...base,
        category: "",
        imageTag: "",
        ratingText: "Premium Quality Product",
        title: "",
        description: "",
        features: [createEmptyPoint(), createEmptyPoint(), createEmptyPoint()],
        primaryCta: { label: "Order Now", url: "" },
        secondaryCta: { label: "Contact Us", url: "/contact" }
      };
    case "useCases":
      return {
        ...base,
        badge: "Health Applications",
        title: "Everyday Use Cases",
        description: "",
        image: "",
        items: [""]
      };
    case "featureSplit":
      return {
        ...base,
        badge: "PREMIUM VALUE",
        title: "",
        description: "",
        image: "",
        imagePosition: "left",
        cardTitle: "",
        points: [createEmptyPoint()]
      };
    case "featureList":
      return {
        ...base,
        title: "",
        image: "",
        imagePosition: "right",
        points: [createEmptyPoint()]
      };
    case "infographics":
      return {
        ...base,
        images: [""]
      };
    case "table":
      return {
        ...base,
        caption: "Specifications",
        headers: ["Tests", "Method", "Grade 1", "Grade 2"],
        rows: [
          ["Appearance", "Visual", "", ""],
          ["", "", "", ""]
        ]
      };
    default:
      return base;
  }
}

export function createDefaultDetailSections() {
  return {
    version: 1,
    sections: []
  };
}

export function parseDetailSections(raw) {
  if (!raw || !String(raw).trim()) {
    return createDefaultDetailSections();
  }

  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!parsed || typeof parsed !== "object") {
      return createDefaultDetailSections();
    }

    const sections = Array.isArray(parsed.sections)
      ? parsed.sections.map((section) => ({
          ...createEmptySection(section?.type || "hero"),
          ...section,
          id: section?.id || uid()
        }))
      : [];

    return {
      version: Number(parsed.version) || 1,
      sections
    };
  } catch {
    return createDefaultDetailSections();
  }
}

export function serializeDetailSections(doc) {
  if (!doc || !Array.isArray(doc.sections) || doc.sections.length === 0) {
    return null;
  }

  const cleaned = {
    version: 1,
    sections: doc.sections.map((section) => {
      const next = { ...section };
      delete next.id;
      return next;
    })
  };

  return JSON.stringify(cleaned);
}
